export default __webpack_public_path__ + "static/plesk-d351e58d5ae0d5eba7a83a4e2edfb82a.webp";